import React from 'react';
import { vars } from '../../theme';
import { Close24 } from '@honeybook/icons';
import styled from 'styled-components';
import HBTooltip from '../HBTooltip/HBTooltip';
import HBText from '../HBText/HBText';
import { hideInPrint } from '../../styles/mixins';
import HBClickable from '../HBClickable/HBClickable';

interface HBModalCloseButtonProps {
    onClose(): void;
    closeButtonText?: string;
    closeButtonTooltipText?: string;
    closeIconColor?: string;
}

const HBModalCloseButton = ({
    onClose,
    closeButtonText,
    closeButtonTooltipText,
    closeIconColor = vars.colors.text.primary
}: HBModalCloseButtonProps) => {
    return (
        <CloseContainer
            onClick={onClose}
            aria-label="close dialog"
            testId="hb-modal-close--button"
        >
            {closeButtonText && (
                <CloseText type="emphasis16" color="text.tertiary">
                    {closeButtonText}
                </CloseText>
            )}
            {closeButtonTooltipText ? (
                <HBTooltip
                    placement="top"
                    target={<Close24 color={closeIconColor} />}
                >
                    {closeButtonTooltipText}
                </HBTooltip>
            ) : (
                <Close24 color={closeIconColor} />
            )}
        </CloseContainer>
    );
};

export default HBModalCloseButton;

// -------------------------------- Styles -------------------------------- //

export const CloseContainer = styled(HBClickable)`
    position: absolute;
    right: 16px;
    top: 18px;
    height: 24px;
    cursor: pointer;
    display: flex;
    align-items: center;
    z-index: 1;
    ${hideInPrint}
    i {
        line-height: 0;
    }
`;

export const CloseText = styled(HBText)`
    margin-right: 10px;
    margin-top: 1px;
`;
